import {Reward} from "@app/main/content/game-settings/popup/content/reward.model";
import {Embed} from "@app/main/content/game-settings/popup/content/embed.model";

export class ContentModel {
  type?: string;
  data?: any;
  reward?: Reward = new Reward();
  embed?: Embed = new Embed();

  constructor(content?) {
    this.type = (content && content.type) ? content.type : '';
    this.data = (content && content.data) ? content.data : {};
    this.reward = (content && content.reward) ? content.reward : this.reward;
    this.embed = (content && content.embed) ? content.embed : this.embed;
  }

}
